import EntityAudits from "@/components/EntityAudits.vue";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  permits: "Permit.Permits",
  list: "Permit.PermitList",
  base: "Permit.PermitBase",
  view: "Permit.PermitView,",
  new: "Permit.PermitNew",
  edit: "Permit.PermitEdit",
  notes: "Permit.PermitNotes",
  noteEdit: "Permit.PermitNoteEdit",
  noteNew: "Permit.PermitNoteNew",
  documents: "Permit.PermitDocuments",
  documentEdit: "Permit.PermitDocumentEdit",
  documentNew: "Permit.PermitDocumentNew",
  audit: "Permit.PermitAudit",
};

export { names as permitRouteNames };

const permitRoutes: RouterOptions["routes"] = [
  {
    path: "/permits",
    name: names.permits,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Permits", lookupGroups: ["Staff", "PermitStatus"] },
        component: () => import("@/views/permit/PermitList.vue"),
      },
      {
        path: "new/:facilityId(\\d+)?",
        component: () => import("@/views/permit/PermitBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Permit New", isNew: true },
            component: () => import("@/views/permit/PermitEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/permit/PermitBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Permit View" },
            component: () => import("@/views/permit/PermitView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Permit Edit", isForm: true },
            component: () => import("@/views/permit/PermitEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Permit Notes" },
            component: {
              render: () => <EntityNotes idField="permitId" routeNamePrefix="Permit.PermitNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Permit Note Edit", isForm: true },
            component: () => import("@/views/permit/PermitNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Permit Note New", isForm: true },
            component: () => import("@/views/permit/PermitNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Permit Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="permit" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Permit Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="permit" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Permit Document", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="permit" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Permit Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Permit" />,
            },
          },
        ],
      },
    ],
  },
];
export default permitRoutes;
